import request from '@/utils/request'

// 조회
export function getPerformanceEvaluationProcedure(params, isProgress) {
  return request({
    url: `/api/getPerformanceEvaluationProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 예시
export function getPerformanceEvaluationProcedureSample(isProgress) {
  return request({
    url: `/api/getPerformanceEvaluationProcedureSample`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 저장
export function savePerformanceEvaluationProcedure(params, isProgress) {
  return request({
    url: `/api/savePerformanceEvaluationProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}
// 삭제
export function deletePerformanceEvaluationProcedure(params, isProgress) {
  return request({
    url: `/api/deletePerformanceEvaluationProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' }
  })
}
// 출력
export function getPerformanceEvaluationProcedureReport (params, isProgress) {
  let responseType = "blob"
  return request({
    url: '/api/getPerformanceEvaluationProcedureReport',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}